<template>
  <modal
    name="morda-lenta-gifts"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    :classes="[
      'v--modal',
      'error-modal',
      'morda-lenta-gifts',
      hasBugs && 'has-bugs',
    ]"
    :width="420"
    :height="'auto'"
    :adaptive="true"
  >
    <div class="modal-title">{{ $t("lentaGifts.synopsis") }}</div>
    <div class="modal-close" @click="close"></div>
    <div v-if="!initIsEmpty('init')" class="modal-body">
      <ul class="morda-lenta-gifts-list">
        <li class="morda-lenta-gifts-title">
          <div class="left">{{ $t("lentaGifts.combination") }}</div>
          <div class="right">{{ $t("lentaGifts.gift") }}</div>
        </li>
        <li
          v-for="(combination, index) in init.mordalenta_prizes"
          class="morda-lenta-gifts-item"
          :key="index"
        >
          <div :class="combination.key" class="left">
            <!-- {{ combination.title }} -->
            {{ $t('lentaGifts.' + combination.key) }}
          </div>
          <ul class="right">
            <li
              v-for="gift in combination.gifts"
              class="morda-lenta-gifts-gift"
              :key="gift.id"
            >
              <img :src="gift.image" alt="" />
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { checkScroll } from "@/mixins/checkScroll";

export default {
  name: "MordaLentaGifts",
  props: {
    i18n: Object,
  },
  mixins: [checkScroll],
  data() {
    return {
      hasBugs: false,
      countIndex: 0,
      loader: false,
      text: "",
    };
  },
  computed: {
    ...mapGetters({
      init: "init/fetchInit",
      initIsEmpty: "init/isEmpty",
    }),
  },
  methods: {
    beforeOpen() {
      this.checkScroll();
    },
    beforeClose() {
      this.checkRemoveScroll();
    },
    close() {
      this.$modal.hide("morda-lenta-gifts");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_morda-lenta-gifts";
</style>
